module.exports = __webpack_public_path__ + "img/TyreLink_Logo_Q.8b73f8f6.png";